module.exports = __webpack_public_path__ + "img/loading-button.59f421f.gif";